import { useAudioPlayerContext } from '../context/audio-player-context';

export const ProgressBar = () => {
  const {
    progressBarRef,
    audioRef,
    timeProgress,
    duration,
    setTimeProgress,
  } = useAudioPlayerContext();

  const handleProgressChange = () => {
    if (audioRef.current && progressBarRef.current) {
      const newTime = Number(progressBarRef.current.value);
      audioRef.current.currentTime = newTime;

      setTimeProgress(newTime);

      // if progress bar changes while audio is on pause
      progressBarRef.current.style.setProperty(
        '--range-progress',
        `${(newTime / duration) * 100}%`
      );
    }
  };

  const formatTime = (time) => {
    if (typeof time === 'number' && !isNaN(time)) {
      const minutes = Math.floor(time / 60);
      const seconds = Math.floor(time % 60);

      // Convert to string and pad with leading zeros if necessary
      const formatMinutes = minutes.toString().padStart(2, '0');
      const formatSeconds = seconds.toString().padStart(2, '0');

      return `${formatMinutes}:${formatSeconds}`;
    }
    return '00:00';
  };

  return (
    <div 
    // className="flex items-center justify-center gap-5 w-full"
    style={{display:"flex", alignItems:"center", justifyContent:"center", gap:"5px", width:"100%"}}
    >
      <span>{formatTime(timeProgress)}</span>
      <input
        // className="max-w-[80%] bg-gray-300"
        style={{maxWidth:"80%", backgroundColor:"#d1d5dc"}}
        ref={progressBarRef}
        type="range"
        defaultValue="0"
        onChange={handleProgressChange}
      />
      <span>{formatTime(duration)}</span>
    </div>
  );
};
